import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetBannersV2} from 'data/usecases';
import {BannersEndPoint} from 'main/factories/usecases/endpoints';
import {GetBannersV2} from 'domain/usecases/private/home/banners-v2';

export const makeGetBannersV2 = (): GetBannersV2 =>
	new RemoteGetBannersV2(
		makeBFFApiUrl(BannersEndPoint.bannersV2),
		makeAuthorizeHttpClientDecorator(),
	);
